module.exports = __webpack_public_path__ + "media/assets/images/group_line_middle-1de9fe93b8339d91dd541b1ea8b2db21.png";